var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareEmailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9546 12.937L19.0001 15.4945V10.2715L14.9546 12.937Z",
    fill: "#1756E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.2715V15.4945L11.0455 12.937L7 10.2715Z",
    fill: "#1756E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2501 8.75H7.74997C7.37572 8.75 7.07871 9.029 7.02246 9.38826L13 13.3266L18.9776 9.38826C18.9214 9.029 18.6243 8.75 18.2501 8.75Z",
    fill: "#1756E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2675 13.3894L13.2063 14.0884C13.1432 14.1297 13.072 14.1499 13 14.1499C12.928 14.1499 12.8567 14.1297 12.7937 14.0884L11.7325 13.3887L7.02393 16.367C7.08168 16.7232 7.37718 17 7.74993 17H18.2501C18.6228 17 18.9183 16.7232 18.9761 16.367L14.2675 13.3894Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmailOutline);
export default __webpack_public_path__ + "static/media/shareEmailOutline.cac4c381a9063af6d2b8559531094a5b.svg";
export { ForwardRef as ReactComponent };